import { ResolveState } from '../../../common';
import { Updater } from '../../../upgrade/models/updater-interface';
import { ErrorResult } from '../../../upgrade/models/error-result';
import { Logger } from '../../utils/logger';

/**
 * the StringReplaceUpdater error handler/updater.
 */
export class StringReplaceUpdater implements Updater {
    /**
     * the update function.
     * @param fileData the file data.
     * @param error the error object.
     * @returns the updated file data.
     */
    public update(fileData: string, error: ErrorResult): Promise<string> {
        if (!fileData) {
            Logger.error(`Cannot find file data`);
        }

        const result = this.regexFixer(fileData);

        error.resolved = ResolveState.Resolved;
        return new Promise(resolve => resolve(result));
    }

    /**
     * the update function.
     * @param inputString the input file data string.
     * @returns the updated file data string.
     */
    private regexFixer(inputString) {
        const regexPattern = /ajaxRequest\.headers/;
        const target = '(<any>ajaxRequest).headers'

        if (regexPattern.test(inputString)) {

            const data = inputString.split('\n');

            for (let i = 0; i < data.length; i++) {
                if (!data[i].includes(target)) {
                    data[i] = data[i].replace('ajaxRequest.headers', target);
                    Logger.log(data[i]);
                }
            }

            return data.join('\n');
        } else {
            Logger.log('no-op')
        }

        return inputString;
    }
}
